export const GENERAL_ERROR_MESSAGE = "We think you found a bug. We're on it!";

export const GENERAL_ERROR_TITLE = 'Oops, something went wrong';
